import { EyeOutlined } from "@ant-design/icons";
import { DateField, useModal } from "@refinedev/antd";
import { useTranslate } from "@refinedev/core";
import { Button, Modal, Space, Table, Typography } from "antd";

import { IEvaluate, IUser, IUserExtended } from "interfaces";
import { useState } from "react";

interface StudentTableProps {
  title: string;
  titleColor: string;
  studentList?: IUser[];
  withReason?: boolean;
}
const { Title, Text } = Typography;
const StudentTable: React.FC<StudentTableProps> = ({ studentList, title, titleColor, withReason }) => {
  const t = useTranslate();
  const { modalProps: modalDetailProps, show: showDetail, close: closeTimeTableReport } = useModal();
  const [detail, setDetail] = useState<IUserExtended | null>();

  return (
    <>
      <Space direction="vertical" style={{ width: "100%" }}>
        <Typography.Title level={5} style={{ color: titleColor }}>
          {title}
        </Typography.Title>

        <Table rowKey="id" dataSource={studentList} scroll={{ x: 300 }}>
          <Table.Column<IUser>
            dataIndex="key"
            key="key"
            title={t("users.fields.idx")}
            render={(_, record, index) => {
              return index + 1;
            }}
          />
          <Table.Column dataIndex={"fullName"} key="fullName" title={t("users.fields.fullName")} />
          <Table.Column dataIndex={"username"} key="username" title={t("users.fields.username")} />
          <Table.Column dataIndex={"email"} key="email" title={t("users.fields.email")} />
          <Table.Column dataIndex={"mobile"} key="mobile" title={t("users.fields.mobile")} />
          <Table.Column
            dataIndex={"additionPoint"}
            key="additionPoint"
            title={t("reports_normal_classes.fields.plusPoints")}
            render={(v) => v && `+${v}`}
          />
          <Table.Column
            dataIndex={"minusPoint"}
            key="minusPoint"
            title={t("reports_normal_classes.fields.minusPoint")}
          />
          {withReason && <Table.Column dataIndex={"reason"} key="reason" title={t("users.fields.reason")} />}
          <Table.Column
            title={t("table.actions")}
            dataIndex="actions"
            render={(_, record: IUserExtended) => {
              return (
                <Space>
                  <Button
                    size="small"
                    icon={<EyeOutlined />}
                    onClick={() => {
                      showDetail();
                      setDetail(record);
                    }}
                  />
                </Space>
              );
            }}
          />
        </Table>
      </Space>
      <Modal
        {...modalDetailProps}
        width={700}
        title={t("reports_normal_classes.titles.details")}
        onCancel={() => {
          setDetail(null);
          closeTimeTableReport();
        }}
        footer={null}
      >
        <Table
          rowKey="id"
          dataSource={detail?.studentEvaluates || []}
          scroll={{ x: 300 }}
          summary={() => (
            <Table.Summary fixed>
              <Table.Summary.Row>
                <Table.Summary.Cell index={0} colSpan={2}>
                  <Title level={5}>{t("reports_normal_classes.fields.total")}</Title>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={1} colSpan={2}>
                  <Text>{(detail?.additionPoint || 0) + (detail?.minusPoint || 0)}</Text>
                </Table.Summary.Cell>
              </Table.Summary.Row>
            </Table.Summary>
          )}
        >
          <Table.Column<IUser>
            dataIndex="key"
            key="key"
            title={t("reports_normal_classes.fields.idx")}
            render={(_, record, index) => {
              return index + 1;
            }}
          />
          <Table.Column<IEvaluate>
            dataIndex={"evaluate"}
            key="evaluate"
            title={t("reports_normal_classes.fields.rewardsViolations")}
            render={(v, r) => r.evaluate.name}
          />
          <Table.Column
            dataIndex={"point"}
            key="point"
            title={t("reports_normal_classes.fields.points")}
            render={(v, r: any) => (
              <span style={{ color: r.evaluate.type === "ADDITIONAL_POINT" ? `#0084FF` : `#FF0000` }}>
                {r.evaluate.type === "ADDITIONAL_POINT" ? `+${v}` : `${v}`}
              </span>
            )}
          />

          <Table.Column
            dataIndex={"updatedAt"}
            key="updatedAt"
            title={t("reports_normal_classes.fields.time")}
            render={(value: any) => <DateField value={value} />}
          />
        </Table>
      </Modal>
    </>
  );
};

export default StudentTable;
